export default __webpack_public_path__ + "images/opera_ec1b2f.svg";